module.exports = __webpack_public_path__ + "img/qseg.94175dda.jpg";